// extracted by mini-css-extract-plugin
export default {"point_name":"PointName_point_name__iack1"};